import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Dashboard.vue'
import ChildVue from '../views/ChildVue.vue'
import MotherVueVue from '@/views/MotherVue.vue'
import NabadoonVueVue from '@/views/NabadoonVue.vue'
import LoginvueVue from '@/views/Loginvue.vue'
import AssignchildVueVue from '@/views/AssignchildVue.vue'
import ReportsVueVue from '@/views/ReportsVue.vue'
import UsersVueVue from '@/views/UsersVue.vue'
import TransferChildVue from '@/views/TransferChildVue.vue'
import LicenceVue from '@/views/LicenceVue.vue'
import ChildAssessmentVue from '@/views/ChildAssessmentVue.vue'
import AssessmentReportVue from '@/views/report/Index.vue'
import DistrictVue from '@/views/DistrictVue.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true, roles: ['admin', 'editor'] }
  },
  {
    path: '/child',
    name: 'child',
    component: ChildVue,
    meta: { requiresAuth: true, roles: ['admin', 'editor'] }
  },
  {
    path: '/mother',
    name: 'mother',
    component: MotherVueVue,
    meta: { requiresAuth: true, roles: ['admin', 'editor'] }
  },
   {
    path: '/nabadoon',
    name: 'nabadoon',
    component: NabadoonVueVue,
    meta: { requiresAuth: true, roles: ['admin', 'editor'] }
  },
   {
    path: '/auth/login',
    name: 'login',
    component: LoginvueVue
  },
  {
    path: '/assign',
    name: 'assign',
    component: AssignchildVueVue,
    meta: { requiresAuth: true, roles: ['admin', 'editor'] }
  },
  {
    path: '/transfer',
    name: 'transfer',
    component: TransferChildVue,
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/users',
    name: 'users',
    component: UsersVueVue,
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/districts',
    name: 'districts',
    component: DistrictVue,
    meta: { requiresAuth: true, roles: ['admin'] }
  },
   {
    path: '/licence',
    name: 'licence',
    component: LicenceVue,
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  {
    path: '/child-assessment',
    name: 'childassessment',
    component: ChildAssessmentVue,
    meta: { requiresAuth: true, roles: ['admin', 'editor'] }
  },
  {
    path: '/assessment-report',
    name: 'assessment-report',
    component: AssessmentReportVue,
    meta: { requiresAuth: true, roles: ['admin','editor'] }
  },
  {
    path: '/report',
    name: 'report',
    component: ReportsVueVue,
    meta: { requiresAuth: true, roles: ['admin'] }
  },
  
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// Global auth/roles guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta && record.meta.requiresAuth)
  if (!requiresAuth) return next()

  // Existing boolean based auth used in views (safe parsing)
  let status = false
  try {
    const s = localStorage.getItem('status')
    status = (s === 'true') || (s === '1') || JSON.parse(s) === true
  } catch (e) {
    status = false
  }
  if (!status) return next({ name: 'login', query: { redirect: to.fullPath } })

  // Optional role checks
  const allowedRoles = to.matched.map(r => (r.meta && r.meta.roles) || null).filter(Boolean).flat()

  try {
    const userRaw = localStorage.getItem('user')
    const user = userRaw ? JSON.parse(userRaw) : {}
    // Backend returns Role as string like 'admin' or 'editor'
    let role = user && user.role

    if (typeof role === 'string') {
      role = role.trim().toLowerCase()
    } else {
      role = null
    }

    // Fallback to legacy usertype key for older sessions
    if (!role) {
      const rt = localStorage.getItem('usertype')
      role = rt ? rt.toString().trim().toLowerCase() : null
    }

    // Non-admin users must have at least one assigned district
    if (role !== 'admin') {
      const hasDistrict = !!(user.district && String(user.district).trim())
        || (Array.isArray(user.districts) && user.districts.length > 0)
      if (!hasDistrict) {
        localStorage.removeItem('status')
        return next({ name: 'login' })
      }
    }

    if (allowedRoles.length === 0) return next()

    const normalizedAllowed = allowedRoles.map(r => String(r).trim().toLowerCase())

    if (role && normalizedAllowed.includes(role)) return next()
    // Not authorized for this route
    return next({ name: 'home' })
  } catch (e) {
    return next({ name: 'home' })
  }
})

export default router

